import React from 'react';
import { VerticalContentsHandler } from 'component/page/detail/DetailPageModularize/ContentsHandler/VerticalContentsHandler';
import { DisplaySectionName } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { Box, Container } from '@drone-js/core';
import { ContentContainerWithSpacing } from 'component/common/ContentContainer/ContentContainer';
import { useSelector } from 'react-redux';
import { selectIsAnyOverlayVisible } from 'store/slice/overlay';
import { DetailPageDisplayConfig } from 'component/page/detail/DetailPageModularize/contentRegistry.type';
import { selectScreenSize } from 'store/slice/screen';

interface Props {
    config: DetailPageDisplayConfig[DisplaySectionName.LandingPageTop];
}

export const LandingPageTopContents: React.FC<Props> = ({ config }) => {
    const { desktopPb, desktopPt, mobilePb, mobilePt } = config.variant;
    const isAnyOverlayVisible: boolean = useSelector(selectIsAnyOverlayVisible);
    const screenSize = useSelector(selectScreenSize);
    const pb = screenSize.desktop ? desktopPb : mobilePb;
    const pt = screenSize.desktop ? desktopPt : mobilePt;

    return (
        <Box
            backgroundColor="base.background.strong"
            overflowY={isAnyOverlayVisible ? 'hidden' : undefined}
            aria-hidden={isAnyOverlayVisible}
            data-testid="detail-page-top-contents"
            borderColor="base.default"
            borderWidth={['1', '0', '0', '0']}
            borderStyle="solid"
        >
            <ContentContainerWithSpacing>
                <div className="DetailContentArea align-center">
                    <Container width="100%" pt={pt} pb={pb}>
                        <VerticalContentsHandler contents={config.contents} />
                    </Container>
                </div>
            </ContentContainerWithSpacing>
        </Box>
    );
};

LandingPageTopContents.displayName = 'LandingPageTopContents';
